<div class="form-group" [formGroup]="formGroup">
            <mat-form-field [ngClass]="{'width-100' : fullWidth}" [hideRequiredMarker]="!isValidatorRequired">
                <input matInput [placeholder]="placeHolderText" [matAutocomplete]="auto" #dpAutoSuggest
                       formControlName="searchText" (focusout)="onFocusOut($event)" [attr.required]="isValidatorRequired" >
                <mat-icon matSuffix *ngIf="showDropdownArrow()">keyboard_arrow_down</mat-icon>
            </mat-form-field>

            <button *ngIf="showDeleteButton" class="mat-card-icon" mat-icon-button
                    (click)="delete()">
                <mat-icon>delete</mat-icon>
            </button>
            <div *ngIf="showWarningMessage"  class="alert alert-warning suggest-warning-message" role="alert">
                  <span>
                      {{warningMessage}}
                  </span>
            </div>

            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)"
                              [displayWith]="displayFn.bind(this)">
                <mat-option *ngIf="isLoading">
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </mat-option>
                <ng-container *ngIf="!isLoading">
                    <mat-option *ngFor="let autoSuggest of autoSuggestList" [value]="autoSuggest">
                        <span>{{ autoSuggest.autoSuggestValueCol1 }}</span>
                        <small class="padding-left-10">{{ autoSuggest.autoSuggestValueCol2 }}</small>
                        <small class="padding-left-10">{{ autoSuggest.autoSuggestValueCol3 }}</small>
                    </mat-option>
                </ng-container>
            </mat-autocomplete>
            <mat-error *ngIf="formGroup.controls['searchText'].errors?.required">
                This field is required
            </mat-error>

            <mat-error *ngIf="formGroup.controls['searchText'].hasError('incorrect')">
                Please select a valid Entry
            </mat-error>
</div>
